/**
 * Find Similar Piece page — Looking Similar + fallbacks.
 * Does not refactor sold-out-alternatives (v1).
 */
(function () {
  'use strict';

  var MIN_HITS = 6;
  var MAX_RECS = 48;
  var MAX_COMPANION = 12;

  function getConfig() {
    return window.__OBLIST_SIMILAR__ || {};
  }

  function getIndexName() {
    var helpers = window.algoliasearch && window.algoliasearch.helpers;
    if (helpers && helpers.getCurrentProductsIndexName) {
      return helpers.getCurrentProductsIndexName();
    }
    return localStorage.getItem('algolia_Index') || 'shopify_theoblistproducts';
  }

  function isSoldOut(hit) {
    if (!hit) return true;
    var sold = hit.meta && hit.meta.custom && hit.meta.custom.soldout;
    if (sold === true || sold === 'true') return true;
    // Align with collection in-stock filter
    if (hit.inventory_available === false) return true;
    return false;
  }

  function filterHits(hits, sourceObjectID) {
    var seen = new Set();
    return (hits || []).filter(function (hit) {
      if (!hit || !hit.objectID) return false;
      if (String(hit.objectID) === String(sourceObjectID)) return false;
      if (isSoldOut(hit)) return false;
      if (seen.has(hit.objectID)) return false;
      seen.add(hit.objectID);
      return true;
    });
  }

  async function getRecommendations(indexName, objectID, model, productType) {
    var requestParams = {
      indexName: indexName,
      objectID: String(objectID),
      model: model,
      threshold: 10,
      maxRecommendations: MAX_RECS,
    };
    if (productType) {
      requestParams.queryParameters = {
        filters: 'product_type:"' + String(productType).replace(/"/g, '') + '"',
      };
    }
    var response = await AlgoliaProxy.recommendClient().getRecommendations({
      requests: [requestParams],
    });
    return (response.results && response.results[0] && response.results[0].hits) || [];
  }

  /**
   * Returns { primary, companion }.
   * primary = same product_type (or sole fallback set)
   * companion = extras from an unfiltered widen — shown in a separate "goes well with" section
   */
  async function fetchWithFallbacks(indexName, objectID, productType) {
    var primary = [];
    var companion = [];

    primary = filterHits(
      await getRecommendations(indexName, objectID, 'looking-similar', productType).catch(function () { return []; }),
      objectID
    );

    if (primary.length < MIN_HITS) {
      var unfiltered = filterHits(
        await getRecommendations(indexName, objectID, 'looking-similar', null).catch(function () { return []; }),
        objectID
      );
      companion = unfiltered.filter(function (hit) {
        return !primary.some(function (p) { return p.objectID === hit.objectID; });
      }).slice(0, MAX_COMPANION);
    }

    if (primary.length === 0 && companion.length === 0) {
      primary = filterHits(
        await getRecommendations(indexName, objectID, 'related-products', productType).catch(function () { return []; }),
        objectID
      );
      if (primary.length < MIN_HITS) {
        var relatedOpen = filterHits(
          await getRecommendations(indexName, objectID, 'related-products', null).catch(function () { return []; }),
          objectID
        );
        companion = relatedOpen.filter(function (hit) {
          return !primary.some(function (p) { return p.objectID === hit.objectID; });
        }).slice(0, MAX_COMPANION);
      }
    }

    // Related returned only open results (no typed primary) → treat as primary, no companion split
    if (primary.length === 0 && companion.length > 0) {
      primary = companion;
      companion = [];
    }

    if (primary.length === 0 && productType) {
      try {
        var searchResult = await AlgoliaProxy.searchClient().initIndex(indexName).search('', {
          hitsPerPage: MAX_RECS,
          filters: 'product_type:"' + String(productType).replace(/"/g, '') + '"',
          analytics: false,
        });
        primary = filterHits(searchResult.hits || [], objectID);
      } catch (e) {
        primary = [];
      }
    }

    return { primary: primary, companion: companion };
  }

  function formatPrice(hit) {
    var helpers = window.algoliasearch && window.algoliasearch.helpers;
    var localized = helpers && helpers.localizeHitData ? helpers.localizeHitData(Object.assign({}, hit)) : hit;
    if (helpers && helpers.getPriceDisplay && localized.price != null) {
      return helpers.getPriceDisplay(localized.currency || 'eur', localized.price);
    }
    if (localized.price != null) {
      return Math.round(Number(localized.price)) + '€';
    }
    return '';
  }

  function syncPrices() {
    if (window.ShopifyPriceSync) {
      window.ShopifyPriceSync.syncVisible();
    }
  }

  function imageUrl(hit) {
    var helpers = window.algoliasearch && window.algoliasearch.helpers;
    if (helpers && helpers.grandeImage) return helpers.grandeImage(hit);
    return hit.product_image || hit.image || hit.featured_image || '';
  }

  function secondaryImageUrl(hit) {
    // Match collection cards: second media when available, else same as primary
    var helpers = window.algoliasearch && window.algoliasearch.helpers;
    var images = hit.images || hit.media || [];
    var second = null;
    if (Array.isArray(images) && images.length > 1) {
      second = typeof images[1] === 'string' ? images[1] : (images[1] && (images[1].src || images[1].url));
    }
    if (second && helpers && helpers.sizedImage) {
      try {
        return helpers.sizedImage('grande', { product_image: second });
      } catch (e) {
        /* fall through */
      }
    }
    if (second) return second;
    return imageUrl(hit);
  }

  function productUrl(hit) {
    var helpers = window.algoliasearch && window.algoliasearch.helpers;
    if (helpers && helpers.instantsearchLink) return helpers.instantsearchLink(hit);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'products/' + (hit.handle || '');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderSeed(seed, config) {
    var el = document.getElementById('similar-pieces-seed');
    if (!el || !seed) return;

    var helpers = window.algoliasearch && window.algoliasearch.helpers;
    var localized = helpers && helpers.localizeHitData ? helpers.localizeHitData(Object.assign({}, seed)) : seed;
    var img = imageUrl(localized);
    var title = localized.title || config.handle || '';
    var href = productUrl(localized);
    var handle = localized.handle || config.handle || '';
    var objectID = localized.objectID || config.objectID || '';

    // handle + empty sale-price → no Algolia price flash; ShopifyPriceSync fills the real market price
    el.setAttribute('handle', handle);
    el.setAttribute('data-variant-id', String(objectID));
    el.innerHTML =
      '<a class="similar-pieces__seed-media" href="' + escapeHtml(href) + '">' +
        (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '" width="96" height="120" loading="eager">' : '') +
      '</a>' +
      '<div class="similar-pieces__seed-meta">' +
        '<p class="similar-pieces__seed-kicker">' + escapeHtml(config.i18n.similarTo || 'Similar to') + '</p>' +
        '<a class="similar-pieces__seed-title" href="' + escapeHtml(href) + '">' + escapeHtml(title) + '</a>' +
        '<price-list class="price-list similar-pieces__seed-price">' +
          '<sale-price class="text-subdued price--loading" data-variant-id="' + escapeHtml(String(objectID)) + '">' +
            '<span class="sr-only">Price</span>' +
          '</sale-price>' +
        '</price-list>' +
      '</div>';
  }

  function groupByType(hits) {
    var groups = {};
    var order = [];
    hits.forEach(function (hit) {
      var key = hit.product_type || '__other__';
      if (!groups[key]) {
        groups[key] = [];
        order.push(key);
      }
      groups[key].push(hit);
    });
    // Soft group only if real diversity
    if (order.length < 2) return null;
    var meaningful = order.filter(function (k) { return groups[k].length >= 2; });
    if (meaningful.length < 2) return null;
    return { groups: groups, order: order };
  }

  function renderCard(hit) {
    var helpers = window.algoliasearch && window.algoliasearch.helpers;
    var localized = helpers && helpers.localizeHitData ? helpers.localizeHitData(Object.assign({}, hit)) : hit;
    var img = imageUrl(localized);
    var imgSecondary = secondaryImageUrl(localized);
    var href = productUrl(localized);
    var title = localized.title || '';
    var handle = localized.handle || '';
    var objectID = localized.objectID || '';
    var sizes =
      '(max-width: 699px) calc(100vw / 2 - 40px), (max-width: 999px) calc(100vw / 3 - 64px), calc(min(100vw - 96px, 1300px) / 4 - (24px / 4 * 3))';

    // Same structure as Algolia collection cards (primary + secondary for hover swap).
    // Leave sale-price empty until ShopifyPriceSync writes the market/PDP price (no Algolia flash).
    return (
      '<product-card handle="' + escapeHtml(handle) + '" data-variant-id="' + escapeHtml(String(objectID)) + '" class="product-card product-card--blends product-card--show-secondary-media bg-custom text-custom" style="--background: 255 255 255; --text-color: 8 8 13;">' +
        '<a href="' + escapeHtml(href) + '" aria-label="' + escapeHtml(title) + '">' +
          '<div class="product-card__figure">' +
            (img
              ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '" loading="lazy" width="1283" height="1723" sizes="' + sizes + '" class="product-card__image product-card__image--primary object-fill-safe aspect-tall">' +
                '<img src="' + escapeHtml(imgSecondary) + '" alt="' + escapeHtml(title) + '" loading="lazy" width="1749" height="2349" fetchpriority="low" sizes="' + sizes + '" class="product-card__image product-card__image--secondary object-fill">'
              : '') +
          '</div>' +
        '</a>' +
        '<a href="' + escapeHtml(href) + '" aria-label="' + escapeHtml(title) + '">' +
          '<div class="product-card__info">' +
            '<div class="v-stack gap-0.5 w-full">' +
              '<span class="product-card__title"><h3 class="">' + escapeHtml(title) + '</h3></span>' +
              '<price-list class="price-list">' +
                '<sale-price class="text-subdued price--loading" data-variant-id="' + escapeHtml(String(objectID)) + '">' +
                  '<span class="sr-only">Price</span>' +
                '</sale-price>' +
              '</price-list>' +
            '</div>' +
          '</div>' +
        '</a>' +
      '</product-card>'
    );
  }

  function renderHitsBlock(hits, config) {
    var grouped = groupByType(hits);
    if (!grouped) {
      return '<div class="similar-pieces__grid">' + hits.map(renderCard).join('') + '</div>';
    }
    return grouped.order.map(function (type) {
      var label = type === '__other__' ? (config.i18n.otherResults || 'Other results') : type;
      return (
        '<section class="similar-pieces__group">' +
          '<h2 class="similar-pieces__group-title">' + escapeHtml(label) + '</h2>' +
          '<div class="similar-pieces__grid">' +
            grouped.groups[type].map(renderCard).join('') +
          '</div>' +
        '</section>'
      );
    }).join('');
  }

  function companionTitle(config, seedTitle) {
    var prefix = (config.i18n && config.i18n.goesWellWith) || 'Also in the spirit of';
    return seedTitle ? (prefix + ' ' + seedTitle) : prefix;
  }

  function renderGrid(primary, companion, config, seed) {
    var container = document.getElementById('similar-pieces-grid');
    var empty = document.getElementById('similar-pieces-empty');
    var loading = document.getElementById('similar-pieces-loading');
    if (loading) loading.hidden = true;

    if (!container) return;

    var hasPrimary = primary && primary.length;
    var hasCompanion = companion && companion.length;

    if (!hasPrimary && !hasCompanion) {
      container.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    var html = '';
    if (hasPrimary) {
      html += renderHitsBlock(primary, config);
    }

    if (hasCompanion) {
      var helpers = window.algoliasearch && window.algoliasearch.helpers;
      var localizedSeed = seed && helpers && helpers.localizeHitData
        ? helpers.localizeHitData(Object.assign({}, seed))
        : seed;
      var seedTitle = (localizedSeed && localizedSeed.title) || config.handle || '';
      html +=
        '<section class="similar-pieces__companion">' +
          '<h2 class="similar-pieces__companion-title">' + escapeHtml(companionTitle(config, seedTitle)) + '</h2>' +
          '<div class="similar-pieces__grid">' +
            companion.map(renderCard).join('') +
          '</div>' +
        '</section>';
    }

    container.innerHTML = html;
    syncPrices();
  }

  async function init() {
    var config = getConfig();
    var objectID = config.objectID;
    var root = document.getElementById('similar-pieces');
    if (!root || !objectID) {
      var empty = document.getElementById('similar-pieces-empty');
      var loading = document.getElementById('similar-pieces-loading');
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    var backBtn = document.getElementById('similar-pieces-back');
    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.OblistSimilarReturn) {
          window.OblistSimilarReturn.goBack();
        } else if (document.referrer) {
          window.location.href = document.referrer;
        } else {
          window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        }
      });
    }

    if (!window.AlgoliaProxy) {
      renderGrid([], [], config, null);
      return;
    }

    var indexName = getIndexName();
    var seed = null;

    try {
      seed = await AlgoliaProxy.getObject(indexName, String(objectID));
    } catch (e) {
      // Fallback: search by handle
      if (config.handle) {
        try {
          var byHandle = await AlgoliaProxy.searchClient().initIndex(indexName).search('', {
            hitsPerPage: 1,
            facetFilters: ['handle:' + config.handle],
            analytics: false,
          });
          seed = (byHandle.hits && byHandle.hits[0]) || null;
        } catch (err) {
          seed = null;
        }
      }
    }

    if (seed) {
      renderSeed(seed, config);
      if (!objectID && seed.objectID) objectID = seed.objectID;
    }

    var productType = (seed && seed.product_type) || config.productType || '';
    var result = await fetchWithFallbacks(indexName, objectID, productType);
    renderGrid(result.primary, result.companion, config, seed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
